import { Policy, PolicyRule } from './types';

export const POLICIES = {
  [Policy.AdministratorAccess]: [PolicyRule.FullAdmin, PolicyRule.AccountAdmin],
  [Policy.FullReadAccess]: [PolicyRule.FullRead],
  [Policy.ApiKeyUserAccess]: [PolicyRule.APIKey],
  [Policy.AppAccess]: [
    PolicyRule.ComplianceAccess,
    PolicyRule.ComplianceAdmin,
    PolicyRule.AssetsAccess,
    PolicyRule.AssetsAdmin,
    PolicyRule.PoliciesAccess,
    PolicyRule.PoliciesAdmin,
    PolicyRule.InsightsAccess,
    PolicyRule.InsightsAdmin,
    PolicyRule.MySecurityAccess,
    PolicyRule.MySecurityAdmin,
    PolicyRule.IntegrationsAccess,
    PolicyRule.IntegrationsAdmin,
    PolicyRule.LandingAccess,
    PolicyRule.LandingAdmin,
    PolicyRule.GalaxyAccess,
    PolicyRule.GalaxyAdmin,
    PolicyRule.RulesAccess,
    PolicyRule.RulesAdmin,
    PolicyRule.EndpointComplianceAccess,
    PolicyRule.EndpointComplianceAdmin,
  ],
  [Policy.SharedAccess]: [
    PolicyRule.ReadGraph,
    PolicyRule.WriteGraph,
    PolicyRule.ReadQuestions,
    PolicyRule.WriteQuestions,
  ],
};

export const POLICIES_BY_RULE = {
  [PolicyRule.FullAdmin]: Policy.AdministratorAccess,
  [PolicyRule.AccountAdmin]: Policy.AdministratorAccess,
  [PolicyRule.FullRead]: Policy.FullReadAccess,
  [PolicyRule.APIKey]: Policy.ApiKeyUserAccess,
  [PolicyRule.ComplianceAccess]: Policy.AppAccess,
  [PolicyRule.ComplianceAdmin]: Policy.AppAccess,
  [PolicyRule.AssetsAccess]: Policy.AppAccess,
  [PolicyRule.AssetsAdmin]: Policy.AppAccess,
  [PolicyRule.PoliciesAccess]: Policy.AppAccess,
  [PolicyRule.PoliciesAdmin]: Policy.AppAccess,
  [PolicyRule.InsightsAccess]: Policy.AppAccess,
  [PolicyRule.InsightsAdmin]: Policy.AppAccess,
  [PolicyRule.MySecurityAccess]: Policy.AppAccess,
  [PolicyRule.MySecurityAdmin]: Policy.AppAccess,
  [PolicyRule.IntegrationsAccess]: Policy.AppAccess,
  [PolicyRule.IntegrationsAdmin]: Policy.AppAccess,
  [PolicyRule.LandingAccess]: Policy.AppAccess,
  [PolicyRule.LandingAdmin]: Policy.AppAccess,
  [PolicyRule.GalaxyAccess]: Policy.AppAccess,
  [PolicyRule.GalaxyAdmin]: Policy.AppAccess,
  [PolicyRule.RulesAccess]: Policy.AppAccess,
  [PolicyRule.RulesAdmin]: Policy.AppAccess,
  [PolicyRule.EndpointComplianceAccess]: Policy.AppAccess,
  [PolicyRule.EndpointComplianceAdmin]: Policy.AppAccess,
  [PolicyRule.ReadGraph]: Policy.SharedAccess,
  [PolicyRule.WriteGraph]: Policy.SharedAccess,
  [PolicyRule.ReadQuestions]: Policy.SharedAccess,
  [PolicyRule.WriteQuestions]: Policy.SharedAccess,
};
